export default {
  configureThor() {
    if (this.thor) {
      this.ajax = true;
      this.thorModel = this.config.thorModel;
      this.Model = Thor[this.thorModel];
    }
  },
  fetchThor(params) {
    const deferred = $.Deferred();
    this.Model.get(params).then(data => {
      deferred.resolve(data);
    }).catch(err => deferred.reject(err));

    return deferred.promise();
  }
};
